import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-search-button',
	templateUrl: './search-button.component.html',
	styleUrls: ['./search-button.component.scss']
})
export class SearchButtonComponent {
	@Input() public tableName: string;
	@Output() public showSearchBarAction = new EventEmitter<void>();

	public showSearchBar(): void {
		this.showSearchBarAction.emit();
	}
}
